module.exports = __webpack_public_path__ + "img/img_value_02.d86544d7.png";